import React, {useEffect, useState} from "react";
import TransactionList from "./TransactionList";

const TransactionAddition = (props) => {
    const {transactions,dispatch} = props;
    return (
        <>
            <TransactionList
                wallets={transactions}
                dispatch={dispatch}
                subClass={" medium-12 small-12"}
                />
        </>
    );
}
export default TransactionAddition;